
import { Component, Vue } from 'vue-property-decorator'
import { fabric } from 'fabric'
@Component({})
export default class extends Vue {
    canvas!: any
    signaturePath!:any

    isSignature = true
    mounted() {
      this.init()
    }

    init() {
      this.canvas = new fabric.Canvas(this.$refs.signatureCanvas as HTMLCanvasElement, {
        isDrawingMode: true
      })
      this.canvas.freeDrawingBrush.width = 3
      this.canvas.on('object:added', () => {
        this.checkSignature()
      })
    }

    checkSignature() {
      this.isSignature = this.canvas.isEmpty()
    }

    clearSignature() {
      this.canvas.clear()
    }

    closeSignature() {
      this.$emit('closeSignature')
    }

    async saveSignature() {
      if (this.canvas.isEmpty()) return
      const dataUrl = await this.canvas.toDataURL({
        format: 'png',
        quality: 1
      })
      this.$emit('updateSignature', dataUrl)
    }
}
